module.exports = __webpack_public_path__ + "img/10893_L.e5457e2f.png";